var AutoBillType = /* @__PURE__ */ ((AutoBillType2) => {
  AutoBillType2[AutoBillType2["None"] = 0] = "None";
  AutoBillType2[AutoBillType2["Unknown"] = -1] = "Unknown";
  AutoBillType2[AutoBillType2["CreditCard"] = 1] = "CreditCard";
  AutoBillType2[AutoBillType2["DirectDebit"] = 2] = "DirectDebit";
  return AutoBillType2;
})(AutoBillType || {});
var PaymentSource = /* @__PURE__ */ ((PaymentSource2) => {
  PaymentSource2[PaymentSource2["CallCenter"] = 3] = "CallCenter";
  PaymentSource2[PaymentSource2["Website"] = 10] = "Website";
  return PaymentSource2;
})(PaymentSource || {});
var CreditCardTypeId = /* @__PURE__ */ ((CreditCardTypeId2) => {
  CreditCardTypeId2[CreditCardTypeId2["Mastercard"] = 5] = "Mastercard";
  CreditCardTypeId2[CreditCardTypeId2["Visa"] = 6] = "Visa";
  CreditCardTypeId2[CreditCardTypeId2["AmericanExpress"] = 7] = "AmericanExpress";
  CreditCardTypeId2[CreditCardTypeId2["Discover"] = 8] = "Discover";
  CreditCardTypeId2[CreditCardTypeId2["Diners"] = 9] = "Diners";
  return CreditCardTypeId2;
})(CreditCardTypeId || {});
export {
  AutoBillType,
  CreditCardTypeId,
  PaymentSource
};
//# sourceMappingURL=sitelink.mjs.map